import script from "./ExpansionWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpansionWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./ExpansionWrapper.vue?vue&type=style&index=0&id=2f9bf542&lang=less"

const __exports__ = script;

export default __exports__